import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { getShortUniqueId } from 'services/uniqueId';

interface IGuestStore {
  guestId: string;
  setGuestId: (guestId: string) => void;
}

export const useGuestStore = create<IGuestStore>()(
  persist(
    set => ({
      guestId: '',
      setGuestId: guestId => set({ guestId }),
    }),
    {
      name: 'guestState',
      storage: createJSONStorage(() => localStorage),
      partialize: ({ guestId }) => ({ guestId }),
    },
  ),
);

const persistGuestIdIfMissing = () => {
  if (!useGuestStore.getState().guestId) {
    useGuestStore.setState({ guestId: getShortUniqueId() });
  }
};

if (typeof window !== 'undefined') {
  if (useGuestStore.persist.hasHydrated()) {
    persistGuestIdIfMissing();
  } else {
    useGuestStore.persist.onFinishHydration(persistGuestIdIfMissing);
  }
}
